import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getServerInfo} from '../../../../../selectors'
import {isPipelinesEnabledInExclusiveMode} from '../../../../pages/PipelinesPages/utils/featureToggles'

import Footer from './Footer'
import type {StateProps} from './Footer.types'

const mapStateToProps = (state: State): StateProps => {
  const {licenseModeName, buildNumber} = getServerInfo(state) || {}
  return {
    licenseModeName: isPipelinesEnabledInExclusiveMode() ? 'Pipelines' : licenseModeName,
    buildNumber,
  }
}

export default connect(mapStateToProps, {})(Footer)
